import styled from "styled-components";

export const ContentGrid = styled.div`
  width: 100%;
  height: calc(100vh - 300px);
  position: relative;
  background-color: #f4f5f5;
`;
export const ContentGridTable = styled.div`
  height: 100%;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  overflow-x: auto;
  overflow-y: auto;

  table {
    border-spacing: 10px;
    border-collapse: separate;
    position: relative;
    margin-left: auto;
    margin-right: auto;

    thead {
      th {
        position: sticky;
        top: 0;
        padding: 13px;
        &:nth-child(1) {
          background-color: #3aa7de;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #3aa7de;
            color: white;
          }
        }
        &:nth-child(2) {
          background-color: #508dca;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #508dca;
            color: white;
          }
        }
        &:nth-child(3) {
          background-color: #33abad;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #33abad;
            color: white;
          }
        }
        &:nth-child(4) {
          background-color: #7f57a2;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #7f57a2;
            color: white;
          }
        }
        &:nth-child(5) {
          background-color: #cd7a83;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #cd7a83;
            color: white;
          }
        }
        &:nth-child(6) {
          background-color: #d3a466;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #d3a466;
            color: white;
          }
        }
        &:nth-child(7) {
          background-color: #7dbcc1;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #7dbcc1;
            color: white;
          }
        }
        &:nth-child(8) {
          background-color: #d2baa1;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #d2baa1;
            color: white;
          }
        }
        &:nth-child(9) {
          background-color: #e7373e;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #e7373e;
            color: white;
          }
        }
        &:nth-child(10) {
          background-color: #85a167;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #85a167;
            color: white;
          }
        }
        &:nth-child(11) {
          background-color: #18b04b;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #18b04b;
            color: white;
          }
        }
        &:nth-child(12) {
          background-color: #88c240;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #88c240;
            color: white;
          }
        }
        &:nth-child(13) {
          background-color: #00a891;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #00a891;
            color: white;
          }
        }
        &:nth-child(14) {
          background-color: #f36822;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #f36822;
            color: white;
          }
        }
        &:nth-child(15) {
          background-color: #3022f3;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #3022f3;
            color: white;
          }
        }
        &:nth-child(16) {
          background-color: #701a5e;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #701a5e;
            color: white;
          }
        }
        &:nth-child(17) {
          background-color: #090808;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #090808;
            color: white;
          }
        }
        &:nth-child(18) {
          background-color: #307c1d;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #307c1d;
            color: white;
          }
        }
        &:nth-child(19) {
          background-color: #165061;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #165061;
            color: white;
          }
        }
        &:nth-child(20) {
          background-color: #5f5f5f;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #5f5f5f;
            color: white;
          }
        }
        &:nth-child(21) {
          background-color: #7a8040;
          border-radius: 5px;
          margin: 5px;
          div {
            background-color: #7a8040;
            color: white;
          }
        }
      }
    }

    tbody {
      tr {
        td {
          text-align: left;
          background-color: #ffffff;
          padding-left: 1rem;
          border-radius: 5px;
          border: 0.6px solid #5f5f5f69;
          margin: 5px;
          cursor: pointer;
          div {
            color: rgb(61, 61, 61);
          }
        }
      }
    }
  }
`;
